import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import { useSelector } from 'react-redux';
import avatar1 from '../../assets/images/users/user.jpg';

import { getUserAvatar, handleAvatarError } from '../../utils/avatar';
import { usePermission } from '../../contexts/PermissionContext';

const ProfileDropdown = () => {
  const { user } = useSelector(state => state.Login);
  const { can, isMenuLoading } = usePermission();
  const canViewActivityLog =
    !isMenuLoading && can('canRead', '/apps-activity-log/view');
  const [userName, setUserName] = useState('');
  const [userRole, setUserRole] = useState('');
  const [userAvatar, setUserAvatar] = useState(avatar1);
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);

  useEffect(() => {
    if (user && typeof user === 'object') {
      let name = '';
      let role = '';
      let avatar = getUserAvatar(user.photo); // use utility function

      switch (process.env.REACT_APP_DEFAULTAUTH) {
        case 'jwt':
          name = user.username || user.name || user.email || 'User';
          role = user.role || 'Role';
          break;
        case 'firebase':
          name = user.email || 'User';
          role = user.role || 'Role';
          break;
        default:
          // Default fallback
          name = user.username || user.name || user.email || 'User';
          role = user.role || 'Role';
          break;
      }

      setUserName(name);
      setUserRole(role);
      setUserAvatar(avatar);
    } else {
      setUserName('User');
      setUserRole('Role');
      setUserAvatar(avatar1);
    }
  }, [user]);

  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };

  return (
    <Dropdown
      isOpen={isProfileDropdown}
      toggle={toggleProfileDropdown}
      className='ms-sm-3 header-item topbar-user'
    >
      <DropdownToggle
        tag='button'
        type='button'
        className='btn'
        aria-label={`Account menu, ${userName || 'User'}`}
        aria-haspopup='menu'
      >
        <span className='d-flex align-items-center'>
          <img
            className='rounded-circle header-profile-user'
            src={userAvatar}
            alt=''
            onError={handleAvatarError}
          />
          <span className='text-start ms-xl-2'>
            <span className='d-none d-xl-inline-block ms-1 fw-medium user-name-text'>
              {userName || 'User'}
            </span>
            <span className='d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text'>
              {userRole || 'Role'}
            </span>
          </span>
        </span>
      </DropdownToggle>
      <DropdownMenu className='dropdown-menu-end'>
        <DropdownItem tag={Link} to='/profile'>
          <i
            className='ri-account-circle-line text-muted fs-16 align-middle me-2'
            aria-hidden='true'
          ></i>
          <span className='align-middle'>Profile</span>
        </DropdownItem>
        {canViewActivityLog && (
          <DropdownItem tag={Link} to='/apps-activity-log/view'>
            <i
              className='ri-history-line text-muted fs-16 align-middle me-2'
              aria-hidden='true'
            ></i>
            <span className='align-middle'>Activity Log</span>
          </DropdownItem>
        )}
        <div className='dropdown-divider' />
        <DropdownItem tag={Link} to='/logout'>
          <i
            className='ri-logout-box-r-line text-muted fs-16 align-middle me-2'
            aria-hidden='true'
          ></i>
          <span className='align-middle'>Logout</span>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ProfileDropdown;
